
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(5(13|79|9)|021|13|290|422|479|617|720|734|8|982)|2(133|146|230|266|479|518|553|619|754|794|840)|5(96[36]|3(09|78|79)|6(37|4|91)|406|492|511|583|726|854)|6(0(02|2|34)|4(19|48|94)|(53|56|61)8|370|732|86)|1(7(15|33|89)|04|340|58|657|978)|8(4(18|30|6)|9(22|39|75|92)|(09|15|55|73)4|025|22|278|63|666)|7((05|3|99)8|(20|65|79|83)3|(32|63|73)2|195|531|547)|3(5(05|35|91)|7(21|74|81)|9(18|2|43)|[02]30|14|266|334|37|443|697)|9(9(|14|98)|046|166|280|4|457|614|650))$/.test(chunkId);
},
rootOutputDir: "",

    };
}
